<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item>送货清单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.dateId" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.supplyDate | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="printTableData">-->
          <!--打印-->
          <!--</el-button>-->
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" fixed width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" fixed label="产品名称"> </el-table-column>

        <el-table-column prop="spec" align="center" fixed label="规格"> </el-table-column>

        <el-table-column prop="stockTotal" align="center" fixed label="基地供应能力"> </el-table-column>

        <el-table-column align="center" v-for="(item, index) in columnList" :key="index" :label="item.logisticName">
          <template slot-scope="scope">
            <span>{{ scope.row.list[index] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        farmId: "",
        dateId: "",
        supplyId: "",
      },
      tableLoading: false,
      columnList: [],
      tableData: [],
      dateList: [],
      logisticsSiteIdList: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadTakenDate();
    // this.loadColumnTitle();
  },
  methods: {
    /**
     * 加载领货日期列表
     */
    loadTakenDate() {
      this.$http({
        url: global.apiUrl + "/farm/farmTakeDate",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.dateList = res.body.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化表头
     */
    loadColumnTitle() {
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-name",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.columnList = res.body.data.list;
            this.columnList.map(item => {
              this.logisticsSiteIdList.push(item.logisticsSiteId);
            });
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = {
        dateId: this.listParams.dateId,
        farmId: this.listParams.farmId,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      };
      this.$http({
        url: global.apiUrl + "/farm/farm-good-deliver",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.columnList = res.body.data.supplyCentreList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 打印列表数据
     */
    printTableData() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.listParams.farmId = parseInt(vm.$route.params.baseId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
